<template>
	<v-treeview
		:items="items"
		:item-key="itemKey"
		:item-children="itemChildren"
		:open="open"
		:value="value"
		:open-on-click="openOnClick"
		:dense="dense"
		:light="light"
		:selectable="selectable"
		v-bind="$attrs"
		v-on="unhandled_events"
		@input="on_input"
		@update:open="on_update_open"
	>
		<template v-if="$scopedSlots.label" v-slot:label="slotProps">
			<slot name="label" v-bind="slotProps"></slot>
		</template>
		<slot></slot>
	</v-treeview>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		itemKey: {
			type: String,
			default: 'id',
		},
		itemChildren: {
			type: String,
			default: 'children',
		},
		open: {
			type: Array,
			default: () => [],
		},
		value: {
			type: Array,
			default: () => [],
		},
		openOnClick: {
			type: Boolean,
			default: false,
		},
		dense: {
			type: Boolean,
			default: false,
		},
		light: {
			type: Boolean,
			default: false,
		},
		selectable: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		unhandled_events() {
			const { input, 'update:open': updateOpen, ...listeners } = this.$listeners;
			return listeners;
		},
	},
	methods: {
		on_input(value) {
			this.$emit('input', value);
		},
		on_update_open(value) {
			this.$emit('update:open', value);
		},
	},
};
</script>
